import { validateWebsite } from '@/utils/utils';
import { object, string, array, boolean, AnyObject, StringSchema } from 'yup';

export type socialLinkType = {
  links: {
    name: string;
    link?: string;
    status: boolean;
    icon?: string;
    sortIndex?: number;
    validationStr?: string | string[];
    label?: string
  }[];
};

const socialLinkSchema = object({
  name: string().required(),
  link: string()
    .when('status', {
      is: true,
      then: (
        schema: StringSchema<string | undefined, AnyObject, undefined, ''>
      ) => schema.required('Please enter a valid link'),
      otherwise: (
        schema: StringSchema<string | undefined, AnyObject, undefined, ''>
      ) => schema.optional()
    })
    .test({
      name: 'name',
      message: 'Invalid link',
      test: (value, context) =>
        context.parent.status
          ? validateLinkByName(context.parent.name, value?.toString() ?? '')
          : true
    }),

  status: boolean().required()
});

export const socialLinksSchema = object({
  links: array(socialLinkSchema).required()
});

export const getInitialValueByName = (name: socialLinksName) => {
  return initialValues.links.find(row => row.name === name)
}

const validateLinkByName = (name: string, value: string) => {
  let isValid = validateWebsite(value);
  if (!isValid) return false;

  const found = getInitialValueByName(name as socialLinksName);
  if(Array.isArray(found?.validationStr))
    isValid = found?.validationStr?.some((s: string) => value?.toLowerCase().includes((s ?? "")?.toLowerCase()))
  else
    isValid = value?.toLowerCase().includes((found?.validationStr ?? "")?.toLowerCase());

  return isValid;
};

export enum socialLinksName {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  YELP = 'yelp',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin'
}

export const initialValues: socialLinkType = {
  links: [
    {
      name: socialLinksName.GOOGLE,
      icon: 'google',
      status: false,
      link: undefined,
      sortIndex: 1,
      validationStr: 'google',
      label:"Google Business"
    },
    {
      name: socialLinksName.FACEBOOK,
      status: false,
      icon: 'facebook',
      link: undefined,
      sortIndex: 2,
      validationStr: 'facebook',
      label:"Facebook"
    },
    {
      name: socialLinksName.YELP,
      status: false,
      icon: 'yelp',
      link: undefined,
      sortIndex: 3,
      validationStr: 'yelp',
      label:"Yelp"
    },
    {
      name: socialLinksName.INSTAGRAM,
      status: false,
      icon: 'instagram',
      link: undefined,
      sortIndex: 4,
      validationStr: 'instagram',
      label:"Instagram"
    },
    {
      name: socialLinksName.TWITTER,
      status: false,
      icon: 'twitter',
      link: undefined,
      sortIndex: 5,
      validationStr: ['x', 'twitter'],
      label:"X"
    },
    {
      name: socialLinksName.LINKEDIN,
      status: false,
      icon: 'linkedin',
      link: undefined,
      sortIndex: 6,
      validationStr: 'linkedin',
      label:"LinkedIn"
    }
  ]
};
